import { Component } from '@angular/core';

@Component({
  selector: 'sigecom-states',
   template: `
    <router-outlet></router-outlet>
    <!-- <sigecom-loading/> -->
  `,
})
export class StatesComponent {

}
